








import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
	name: "el-input",
})
export default class ElInput extends Vue {
	@Prop({ default: () => `_id${Math.random() * 10000}` })
	id: string;

	@Prop()
	label: string;

	@Prop()
	placeholder: string;

	@Prop()
	value: string;

	@Prop()
	validator: Function;

	@Prop({ default: false }) required: boolean;

	@Prop()
	mask: string | string[];

	updateValue(value) {
		this.$emit("input", value);
	}
}
